<template>
	<div class="data-wrapper financial-data" @click="gotoDetails">
		<div class="financial-header">
			<slot></slot>
		</div>
		<div v-if="showContent" class="financial-content">
			<div class="financial-item" v-for="(value, key) in coreIndicators" :key="key">
				<p class="financial-label">{{ filterCoreLabel(key) }}</p>
				<p class="financial-value" v-html="handleCoreValue(value, key)"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { formatterColTransferUnit } from '@/utils/enterprise';
import i18n, { EN } from '@/assets/js/i18n';
import { useNavigation } from '@rebuild/hooks/useNavigation';

export default {
	props: {
		quarterInfo: {
			type: Object,
			default: () => {
				return {};
			}
		},
		inOverview: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		coreIndicators() {
			const { coreIndicators = {} } = this.quarterInfo;
			return coreIndicators;
		},
		coreLen() {
			return Object.keys(this.coreIndicators).length;
		},
		showContent() {
			return this.coreLen > 0;
		}
	},
	methods: {
		handleCoreValue(val, key) {
			if (
				[
					'roe',
					'roa',
					'grossMargin',
					'assetLiabRatio',
					'npMargin',
					'arTurnover',
					'invenTurnover',
					'caTurnover',
					'faTurnover',
					'taTurnover',
					'revenueYoy',
					'operProfitYoy',
					'niYoy',
					'taYtd',
					'naYtd',
					'currentRatio',
					'quickRatio'
				].includes(key)
			) {
				return val.toFixed(2) + '<span class="financial-unit">%</span>';
			} else {
				const [formatVal, formatUnit = ''] = formatterColTransferUnit(val, true);
				return formatVal + `<span class="financial-unit">${formatUnit}${i18n.locale === EN ? '' : '元'}</span>`;
			}
		},
		filterCoreLabel(key) {
			const CORE_OPTIONS = {
				roe: 'ROE',
				roa: 'ROA',
				nAssetPs: this.$t('enterprise.BVPS'),
				nCInCashPs: this.$t('enterprise.CFPS'),
				grossMargin: this.$t('enterprise.gross-margin'),
				eps: this.$t('enterprise.EPS'),
				assetLiabRatio: this.$t('enterprise.current-debt-ration'),
				reserPs: this.$t('enterprise.CapSurFdPS'),
				rePs: this.$t('enterprise.UPS'),
				revPs: this.$t('enterprise.EPS')
			};

			const WCHKX_OPTIONS = {
				grossRevenue: this.$t('enterprise.total-operating-revenue'),
				profit: this.$t('enterprise.total-operating-revenue'),
				netProfitRate: this.$t('enterprise.NPM')
			};

			const composeOptions = {
				...CORE_OPTIONS,
				...WCHKX_OPTIONS
			};
			return composeOptions[key] || key;
		},
		gotoDetails() {
			if (this.inOverview) {
				this.goToModule('quarterly_performance');
			}
		}
	},
	setup() {
		const { goToModule } = useNavigation();
		return {
			goToModule
		};
	}
};
</script>

<style lang="less" scoped>
.data-wrapper {
	margin-bottom: 0.14rem;
	padding: 0.14rem 0.12rem;
	border-radius: 0.06rem;
	border: 0.02rem solid rgba(255, 255, 255, 0.6);
	background: linear-gradient(180deg, #fff 67.54%, rgba(243, 246, 253, 0.3) 100%);
	overflow: hidden;
}
.financial-data {
	position: relative;
	&::before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		width: 2.3rem;
		height: 0.98rem;
		background: url('@/assets/images/enterprise/wrapper-bg.png');
		background-size: 100% 100%;
	}

	.financial-header {
		position: relative;
		z-index: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.financial-more {
		display: flex;
		align-items: center;

		color: #989898;
		font-family: 'PingFang SC';
		font-size: 0.12rem;
		font-style: normal;
		font-weight: 400;
		line-height: 0.17rem;

		.iconfont {
			font-size: 0.08rem;
		}
	}
	.financial-content {
		margin-top: 0.16rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;

		.financial-item {
			// min-width: calc((100% - (calc(0.5rem * 2))) / 3);
			margin-right: 0.5rem;

			&:last-child {
				margin-right: 0;
			}
		}

		.financial-label {
			color: #666;
			font-family: 'PingFang SC';
			font-size: 0.12rem;
			font-style: normal;
			font-weight: 400;
			line-height: 0.17rem;
			white-space: nowrap;
		}

		.financial-value {
			margin-top: 0.04rem;

			color: #333;
			font-family: Barlow;
			font-size: 0.2rem;
			font-style: normal;
			font-weight: 500;
			line-height: 0.28rem;
			white-space: nowrap;
		}
		/deep/ .financial-unit {
			margin-left: 0.04rem;
			font-size: 0.12rem;
			font-weight: 400;
		}
	}
}
</style>
